export default __webpack_public_path__ + "static/media/img-placeholder-full-width.779e3e51.png";